var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "redirection-details"
  }, [_c('div', {
    staticClass: "redirection-content pa-4"
  }, [_c('div', {
    staticClass: "label font-weight-bold pb-1"
  }, [_vm._v(_vm._s(_vm.$t('scan_destination_title')))]), _c('div', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.$t('scan_destination_hint')))]), _vm.loading ? _c('div', {
    staticClass: "loading-ctn"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary",
      "size": "32"
    }
  })], 1) : _vm._e(), !_vm.loading ? _c('destination-cards', {
    staticClass: "mt-6",
    attrs: {
      "value": _vm.destinationType
    },
    on: {
      "input": _vm.selectDestination
    },
    scopedSlots: _vm._u([_vm.destinationType === 'dpp' && _vm.isUsingDpp && !_vm.isModified ? {
      key: "dpp-action",
      fn: function () {
        return [_c('v-btn', {
          staticClass: "mt-1",
          attrs: {
            "small": "",
            "color": "primary",
            "text": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.openDppEditor.apply(null, arguments);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "left": "",
            "small": ""
          }
        }, [_vm._v("mdi-open-in-new")]), _vm._v(_vm._s(_vm.$t('open_dpp_editor')) + " ")], 1)];
      },
      proxy: true
    } : null, _vm.destinationType === 'custom' && _vm.isUsingCustomPage && !_vm.isModified ? {
      key: "custom-action",
      fn: function () {
        return [_c('v-btn', {
          staticClass: "mt-1",
          attrs: {
            "small": "",
            "color": "primary",
            "text": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.openLandingPageEditor.apply(null, arguments);
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "left": "",
            "small": ""
          }
        }, [_vm._v("mdi-open-in-new")]), _vm._v(_vm._s(_vm.$t('open_editor')) + " ")], 1)];
      },
      proxy: true
    } : null], null, true)
  }) : _vm._e(), !_vm.loading && _vm.destinationType === 'custom' && _vm.showLegacyDppLayout ? _c('div', {
    staticClass: "layout-section mt-6"
  }, [_c('div', {
    staticClass: "section-label"
  }, [_vm._v(_vm._s(_vm.$t('start_from_a_layout')))]), _c('div', {
    staticClass: "layout-cards mt-3"
  }, [_c('destination-option-card', {
    attrs: {
      "orientation": "vertical",
      "icon": "mdi-image",
      "title": _vm.$t('product_showcase'),
      "description": _vm.$t('product_showcase_desc'),
      "selected": _vm.layout === 'showcase'
    },
    on: {
      "select": function ($event) {
        return _vm.selectLayout('showcase');
      }
    }
  }), _c('destination-option-card', {
    attrs: {
      "orientation": "vertical",
      "icon": "mdi-file-document",
      "title": _vm.$t('dpp_page_template'),
      "description": _vm.$t('digital_product_passport_desc'),
      "selected": _vm.layout === 'dpp'
    },
    on: {
      "select": function ($event) {
        return _vm.selectLayout('dpp');
      }
    }
  })], 1)]) : _vm._e(), !_vm.loading && _vm.destinationType === 'existing' ? _c('div', {
    staticClass: "existing-page-select my-6"
  }, [_c('v-autocomplete', {
    ref: "existingSelect",
    attrs: {
      "items": _vm.selectableLandingPages,
      "loading": _vm.landingPagesLoading,
      "search-input": _vm.landingPageSearch,
      "no-filter": true,
      "label": _vm.$t('select_landing_page'),
      "no-data-text": _vm.$t('no_data_available'),
      "menu-props": {
        offsetY: true
      },
      "rules": _vm.rules.stc_config,
      "item-value": "id",
      "item-text": "name",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "clearable": ""
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.landingPageSearch = $event;
      },
      "update:search-input": function ($event) {
        _vm.landingPageSearch = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('div', {
          staticClass: "d-flex align-center",
          staticStyle: {
            "width": "100%"
          }
        }, [_c('span', {
          staticClass: "flex-grow-1 text-truncate"
        }, [_vm._v(_vm._s(item.name))]), _c('span', {
          staticClass: "page-tag"
        }, [_vm._v(_vm._s(_vm.landingPageLayoutTag(item)))])])];
      }
    }, {
      key: "selection",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('span', {
          staticClass: "text-truncate"
        }, [_vm._v(_vm._s(item.name) + " - " + _vm._s(_vm.landingPageLayoutTag(item)))])];
      }
    }], null, false, 1947372199),
    model: {
      value: _vm.form.stc_config,
      callback: function ($$v) {
        _vm.$set(_vm.form, "stc_config", $$v);
      },
      expression: "form.stc_config"
    }
  }), _vm.isBorrowedLandingPage ? _c('div', {
    staticClass: "borrowed-note"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "size": "15"
    }
  }, [_vm._v("mdi-information-outline")]), _c('span', [_vm._v(_vm._s(_vm.$t('landing_page_managed_in_another_product')))])], 1) : _vm._e()], 1) : _vm._e(), !_vm.loading && _vm.destinationType === 'redirect' ? _c('div', {
    staticClass: "mt-6"
  }, [_c('v-form', {
    ref: "urlForm",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('v-text-field', {
    staticClass: "form-input",
    attrs: {
      "label": _vm.$t('URL'),
      "rules": _vm.rules.url,
      "validate-on-blur": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.url,
      callback: function ($$v) {
        _vm.$set(_vm.form, "url", $$v);
      },
      expression: "form.url"
    }
  })], 1)], 1) : _vm._e()], 1), !_vm.loading ? _c('div', {
    staticClass: "actions-ctn"
  }, [_c('v-btn', {
    staticClass: "save-btn px-6",
    attrs: {
      "color": "primary",
      "raised": "",
      "disabled": !_vm.isModified || _vm.saving,
      "loading": _vm.saving
    },
    on: {
      "click": function ($event) {
        return _vm.save();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))]), ['custom', 'dpp'].includes(_vm.destinationType) && _vm.isModified ? _c('span', {
    staticClass: "save-hint"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-information-outline")]), _vm._v(_vm._s(_vm.destinationType === 'dpp' ? _vm.$t('save_destination_to_open_dpp_editor') : _vm.$t('save_destination_to_open_editor')) + " ")], 1) : _vm._e()], 1) : _vm._e(), _c('confirmation-dialog', {
    attrs: {
      "display-confirmation-dialog": _vm.showReplaceWarning,
      "title": _vm.$t('replace_landing_page_title'),
      "content": _vm.$t('replace_landing_page_warning')
    },
    on: {
      "update:displayConfirmationDialog": function ($event) {
        _vm.showReplaceWarning = $event;
      },
      "update:display-confirmation-dialog": function ($event) {
        _vm.showReplaceWarning = $event;
      },
      "handle-confirmation": _vm.onReplaceConfirm
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }